import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ZeroService } from '../../_services/zero/zero.service';
import { REST_SERVICES } from '../../_services/settings';
import { Globals } from '../../_services/zero/globals';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { ReporteRequest } from 'src/app/_models/reportes.model';
import { MovimientosAutomaticos } from 'src/app/_models/movimientos-automaticos-model';
import { Movimiento } from 'src/app/_models/movimiento-model';
import { MovimientosRequest } from 'src/app/_models/movimientos-request-model';
import { PageMovimientos } from 'src/app/_models/page-movimientos-model';
import { DatePipeFormat } from '../../_services/DatePipeFormat';

@Component({
  selector: 'app-movimientos-automaticos',
  templateUrl: './movimientos-automaticos.component.html',
  styleUrls: ['../../semantic/datatable/datatable.component.scss', './movimientos-automaticos.component.css'],
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
  encapsulation: ViewEncapsulation.None
})
export class MovimientosAutomaticosComponent implements OnInit {
  public datePipe: DatePipe;
  public options: Pickadate.DateOptions;
  public filtrosRep: ReporteRequest;
  public filtrosMov: MovimientosRequest;
  public movimientos: Array<Movimiento> = [];
  public rowsDataTables: Array<Movimiento> = [];
  public columnsDataTable: Array<any> = [];
  public page: PageMovimientos;
  public enableExportar: boolean;

  public messages = {
    // Message to show when array is presented
    // but contains no values
    emptyMessage: "No hay información para mostrar",

    // Footer total message
    totalMessage: "total",
  };

  constructor(private zeroService: ZeroService,
    private globals: Globals,
    private toast: ToastrService) {
    this.options = globals.optionsByPickerdate;
    this.datePipe = new DatePipe("es-Mx");
    this.page = new PageMovimientos();
    this.enableExportar = false;
    this.filtrosRep = new ReporteRequest();
    this.filtrosMov = new MovimientosRequest();
  }

  ngOnInit() {
    var fechaHoy = new Date();
    var fechaInicio = new Date();
    var fechaFin = new Date();
    this.filtrosRep.fechaCorte = fechaHoy.toISOString().slice(0, 10);
    this.filtrosRep.periodo = 7;

    if (this.filtrosRep.periodo == 7) {
      fechaInicio.setDate(fechaInicio.getDate() - 8);
      fechaFin.setDate(fechaFin.getDate() - 1);
    } else {
      fechaInicio.setDate(fechaInicio.getDate() - 31);
      fechaFin.setDate(fechaFin.getDate() - 1);
    }
    this.filtrosRep.fechaInicio = fechaInicio.toISOString().slice(0, 10);
    this.filtrosRep.fechaFin = fechaFin.toISOString().slice(0, 10);

    this.columnsDataTable = [
      { name: "BIN", prop: "bin" },
      { name: "PROCESADOR", prop: "procesador", width: 160 },
      { name: "SOLICITUD", prop: "solicitud" },
      { name: "FECHA DE SOLICITUD", prop: "fechaSolicitud" },
      { name: "FECHA DE APLICACIÓN", prop: "fechaAplicacion" },
    ];

    this.buscarMovimientos();
  }

  updateFechas() {
    var fechaInicio = new Date(this.filtrosRep.fechaCorte);
    var fechaFin = new Date(this.filtrosRep.fechaCorte);
    if (this.filtrosRep.periodo == 7) {
      fechaInicio.setDate(fechaInicio.getDate() - 8);
      fechaFin.setDate(fechaFin.getDate() - 1);
    } else {
      fechaInicio.setDate(fechaInicio.getDate() - 31);
      fechaFin.setDate(fechaFin.getDate() - 1);
    }
    this.filtrosRep.fechaInicio = fechaInicio.toISOString().slice(0, 10);
    this.filtrosRep.fechaFin = fechaFin.toISOString().slice(0, 10);
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset + 1;
    this.buscarMovimientos();
  }

  limpiar() {
    var fechaHoy = new Date();
    var fechaInicio = new Date();
    var fechaFin = new Date();
    this.filtrosRep.fechaCorte = fechaHoy.toISOString().slice(0, 10);
    this.filtrosRep.periodo = 7;

    if (this.filtrosRep.periodo == 7) {
      fechaInicio.setDate(fechaInicio.getDate() - 8);
      fechaFin.setDate(fechaFin.getDate() - 1);
    } else {
      fechaInicio.setDate(fechaInicio.getDate() - 31);
      fechaFin.setDate(fechaFin.getDate() - 1);
    }
    this.filtrosRep.fechaInicio = fechaInicio.toISOString().slice(0, 10);
    this.filtrosRep.fechaFin = fechaFin.toISOString().slice(0, 10);
    this.page.pageNumber = 1;
    this.buscarMovimientos();
  }

  buscarInformacion() {    
    this.page.pageNumber = 1;
    this.buscarMovimientos();
  }

  buscarMovimientos() {
    let scope = this;
    this.filtrosMov.fechaCorte = this.filtrosRep.fechaCorte;
    this.filtrosMov.fechaInicio = this.filtrosRep.fechaInicio
    this.filtrosMov.fechaFin = this.filtrosRep.fechaFin;
    this.filtrosMov.periodo = this.filtrosRep.periodo;
    this.filtrosMov.numPagina = this.page.pageNumber;
    this.filtrosMov.tamPagina = this.page.size;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.MOVIMIENTOS_AUTOMATICOS_CONSULTA,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosMov,
      ok: (response) => {
        this.procesaResponseConsulta(response);
        if (response.responseCode.code == "IGBL000") {
          scope.rowsDataTables = new Array<Movimiento>();
          scope.rowsDataTables = response.response.movimientos;
          scope.page.totalElements = response.response.totalRegistros
          if (scope.page.pageNumber > 0) {
            scope.page.pageNumber = scope.page.pageNumber-1;
          } else {
            scope.page.pageNumber = 0;
          }
          scope.page.totalPages = scope.page.totalElements / scope.page.size;
          if (response.response.totalRegistros > 0) {
            this.enableExportar = true;
          }
        } else {
          scope.page.pageNumber = 0;
          scope.page.totalPages = 0;
          scope.page.totalElements = 0;
        }
      },
    });
  }

  exportarExcel() {
    let scope = this;
    this.filtrosRep.idTipoBin = 0;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_MOVIMIENTOS_AUTOMATICOS,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponseReporte(response);
      },
    });
  }

  private procesaResponseReporte(response) {
    if (response.response.archivoReporte != null) {
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}` + ", se estará generando y se notificara cuando este disponible para su descarga. <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al generar el reporte de Movimientos<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  private procesaResponseConsulta(response) {
    if (response.responseCode != null) {
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>Operación realizada exitosamente. <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al consultar información de Movimientos<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }
}
